import * as React from "react";
import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import {
  DetailInnerWrapper,
  DetailPageBox,
} from "../../../components/sharedStyles";
import useActiveFilters from "../../../hooks/useActiveFilters";
// import LeaseContractWithCostsTable from "../../../components/Lists/LeaseContractsWithCosts/FullTableNewVersion";
import LeaseContractWithCostsTable from "src/components/Tables/LeaseContractsWithCosts/FullTableNewVersionRework";

export const PERSISTANT_CATEGORY_KEY = "persistant_category_leasecontract";

export default function LeaseCosts() {
  const { filteredRealEstates } = useActiveFilters();

  const persistantQuery = {
    realestate__in: filteredRealEstates,
    draft: false,
  };

  return (
    <>
      <DetailInnerWrapper>
        <DetailPageBox>
          <OverviewTitleWrapper>
            <OverviewTitle>Hyresavtal</OverviewTitle>
          </OverviewTitleWrapper>

          <LeaseContractWithCostsTable persistantQuery={persistantQuery} />
        </DetailPageBox>
      </DetailInnerWrapper>
    </>
  );
}
